export type IGetDifferenceOfArrays = (arr1: any[], arr2: any[]) => any[];

export function getDifferenceOfArrays(arr1: any[], arr2: any[]): any[] {
  const a: any[] = [];
  const diff: any[] = [];

  for (let i = 0; i < arr1.length; i += 1) {
    a[arr1[i]] = true;
  }

  for (let i = 0; i < arr2.length; i += 1) {
    if (a[arr2[i]]) {
      delete a[arr2[i]];
    } else {
      a[arr2[i]] = true;
    }
  }

  Object.keys(a).forEach((k) => {
    diff.push(k);
  });

  return diff;
}
